import { render, staticRenderFns } from "./noSettlement.vue?vue&type=template&id=81b18efa&scoped=true&"
import script from "./noSettlement.vue?vue&type=script&lang=js&"
export * from "./noSettlement.vue?vue&type=script&lang=js&"
import style0 from "./noSettlement.vue?vue&type=style&index=0&id=81b18efa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b18efa",
  null
  
)

export default component.exports